import { AssessmentStepKeys } from '@/enums'
import { LeadGenerationAssessment } from './BasePage'

interface ApproxRevenue {
  approxTurnover?: number | null
}

interface ApproxLaborCosts {
  approxPersonelExpenses?: number | null
}

interface CompanyFoundedDateLead {
  foundedDate?: number | null
}

interface StepValues {
  approxRevenue: ApproxRevenue
  approxLaborCosts: ApproxLaborCosts
  companyFoundedDateLead: CompanyFoundedDateLead
  [key: string]: any
}

interface TransformedSubmitValues {
  lastYearFinances: ApproxRevenue & ApproxLaborCosts
  companyFoundedDate: CompanyFoundedDateLead
  [key: string]: any
}

interface StepProps {
  categoryId: string
  transformSubmitValues: (values: StepValues) => TransformedSubmitValues
}

type MakeStepPropsFunction = (
  transformSubmitValues: (values: StepValues) => TransformedSubmitValues,
) => Record<string, StepProps>

const professionalLiabilityAssessmentSteps = [
  AssessmentStepKeys.businessType,
  AssessmentStepKeys.companyFoundedDateLead,
  AssessmentStepKeys.approxRevenue,
  AssessmentStepKeys.employeesCount,
  AssessmentStepKeys.approxLaborCosts,
  AssessmentStepKeys.createLead,
]

const makeSubmitValues = ({
  approxRevenue,
  approxLaborCosts,
  companyFoundedDateLead,
  ...steps
}: StepValues): TransformedSubmitValues => ({
  ...steps,
  lastYearFinances: { ...approxLaborCosts, ...approxRevenue },
  companyFoundedDate: companyFoundedDateLead,
})

const makeStepProps: MakeStepPropsFunction = (transformSubmitValues) => ({
  [AssessmentStepKeys.createLead]: {
    categoryId: 'PF',
    transformSubmitValues,
  },
})

export const ProfessionalLiabilityLead = () => (
  <LeadGenerationAssessment
    categoryId="PF"
    stepProps={makeStepProps(makeSubmitValues)}
    stepKeys={professionalLiabilityAssessmentSteps}
  />
)
